$(function () {
    $(document).on('click', 'a.time_tracking_remove', function (e) {
        e.preventDefault();
        if (!confirm('Opravdu smazat záznam?')) {
            return false;
        }
        var url = $(this).attr('href');
        if (typeof url !== "undefined") {
            $.ajax({
                type: 'POST', url: url, async: false, dataType: 'json',
                success: function (data) {
                    if (data.status == 'success') {
                        $('#timerecords_list').html(data.data.content);
                        $('#timetracking-total').text(data.data.timerecords_sum);
                    } else {
                        bootbox.alert(data.msg);
                    }
                },
                error: function (data) { // if error occured
                    bootbox.alert('Chyba při provádění operace');
                }
            });
        }
    });

    $(document).on('click', 'a.edit_time_tracking', function (e) {
        e.preventDefault();
        var url = $(this).attr('href');
        if (typeof url !== "undefined") {
            $.ajax({
                type: 'POST', url: url, async: false, dataType: 'json',
                success: function (data) {
                    if (data.status == 'success') {
                        $('#editTimeTrackingMCRM').html(data.data.content).on('shown.bs.modal', function () {
                            var select = $('#editTimeTrackingMCRM select[autofocus]:first');
                            var input = $('#editTimeTrackingMCRM input[autofocus]:first');
                            if (select.length > 0) {
                                select.focus();
                            }
                            if (input.length > 0) {
                                input.focus();
                            }
                            var choice = $('#editTimeTrackingMCRM select.tag_choice');
                            if (choice.length > 0) {
                                let choices = new Choices(choice[0], {
                                    removeItemButton: true,
                                    placeholder: true,
                                    loadingText: 'Načítání...',
                                    noResultsText: 'Nebyly nalezeny žádné výsledky',
                                    noChoicesText: 'Žádné možnosti na výběr',
                                    itemSelectText: 'Klikněte pro výběr',
                                    uniqueItemText: 'Lze přidat pouze jedinečné hodnoty',
                                });
                                $('#editTimeTrackingMCRM #tag-switch').change(function () {
                                    if ($(this).prop('checked')) {
                                        $('#editTimeTrackingMCRM #tag-select').addClass('d-none');
                                        $('#editTimeTrackingMCRM #tag-new').removeClass('d-none');
                                    } else {
                                        $('#editTimeTrackingMCRM #tag-new').addClass('d-none');
                                        $('#editTimeTrackingMCRM #tag-select').removeClass('d-none');
                                    }
                                });
                            }
                            flatpickr('.flatpickr-datetime', {
                                locale: "cs",
                                allowInput: true,
                                enableTime: true,
                                dateFormat: "d.m.Y H:i",
                                time_24hr: true
                            });
                            flatpickr('.flatpickr-time-24', {
                                locale: "cs",
                                allowInput: true,
                                enableTime: true,
                                noCalendar: true,
                                dateFormat: "H:i",
                                time_24hr: true
                            });
                            // vždy sjednocený formát data: dd.mm.yyyy HH:mm (se zero-paddingem)
                            let pad = function (value) {
                                return value < 10 ? '0' + value : '' + value;
                            };
                            // parsuje "dd.mm.yyyy HH:mm" na Date; vrací null při neplatném vstupu
                            let parseDateTime = function (value) {
                                if (!value) {
                                    return null;
                                }
                                let parts = value.trim().split(' ');
                                let dateParts = parts[0].split('.');
                                let timeParts = (parts[1] || '00:00').split(':');
                                if (dateParts.length < 3) {
                                    return null;
                                }
                                let date = new Date(
                                    parseInt(dateParts[2], 10),
                                    parseInt(dateParts[1], 10) - 1,
                                    parseInt(dateParts[0], 10),
                                    parseInt(timeParts[0], 10) || 0,
                                    parseInt(timeParts[1], 10) || 0
                                );
                                return isNaN(date.getTime()) ? null : date;
                            };
                            // formátuje Date zpět na "dd.mm.yyyy HH:mm"
                            let formatDateTime = function (date) {
                                return pad(date.getDate()) + '.' + pad(date.getMonth() + 1) + '.'
                                    + date.getFullYear() + ' '
                                    + pad(date.getHours()) + ':' + pad(date.getMinutes());
                            };
                            // délka z pole "time" (HH:mm) v ms; když je 0/prázdné, výchozí 1 hodina
                            let getDurationMs = function () {
                                let time = $('#timetracking-time').val().split(':');
                                let totalMinutes = (parseInt(time[0], 10) || 0) * 60 + (parseInt(time[1], 10) || 0);
                                if (totalMinutes <= 0) {
                                    totalMinutes = 60;
                                }
                                return totalMinutes * 60000;
                            };
                            let setTimeFromRange = function (date_from, date_to) {
                                let diff = date_to.getTime() - date_from.getTime();
                                let hours = Math.floor(diff / 1000 / 60 / 60);
                                let minutes = Math.round(diff / 1000 / 60 - hours * 60);
                                $('#timetracking-time').val(pad(hours) + ':' + pad(minutes));
                            };

                            $('#timetracking-date_from').off('change.tt').on('change.tt', function () {
                                let date_from = parseDateTime($(this).val());
                                let date_to = parseDateTime($('#timetracking-date_to').val());
                                if (!date_from || !date_to) {
                                    return;
                                }
                                if (date_from >= date_to) {
                                    date_to = new Date(date_from.getTime() + getDurationMs());
                                    $('#timetracking-date_to').val(formatDateTime(date_to));
                                }
                                setTimeFromRange(date_from, date_to);
                            });
                            $('#timetracking-date_to').off('change.tt').on('change.tt', function () {
                                let date_to = parseDateTime($(this).val());
                                let date_from = parseDateTime($('#timetracking-date_from').val());
                                if (!date_from || !date_to) {
                                    return;
                                }
                                if (date_from >= date_to) {
                                    date_from = new Date(date_to.getTime() - getDurationMs());
                                    $('#timetracking-date_from').val(formatDateTime(date_from));
                                }
                                setTimeFromRange(date_from, date_to);
                            });
                            $('#timetracking-time').off('change.tt').on('change.tt', function () {
                                let data = $(this).val().split(':');
                                let hours = parseInt(data[0], 10) || 0;
                                let minutes = parseInt(data[1], 10) || 0;

                                let date_from = parseDateTime($('#timetracking-date_from').val());
                                if (!date_from) {
                                    return;
                                }
                                let date_to = new Date(date_from.getTime() + (hours * 60 + minutes) * 60000);
                                $('#timetracking-date_from').val(formatDateTime(date_from));
                                $('#timetracking-date_to').val(formatDateTime(date_to));
                            });
                        }).on('hidden.bs.modal', function () {
                            $('#editTimeTrackingMCRM').html('');
                        });
                        $('#timetracking-api-form').on('submit', function (e) {
                            e.preventDefault();
                            if (typeof tinymce !== 'undefined') {
                                tinymce.triggerSave();
                                if (tinymce.activeEditor !== null) {
                                    tinymce.activeEditor.save();
                                }
                            }
                            var form = $(this);
                            var actionUrl = form.attr('action');
                            var form_data = new FormData(form[0]);
                            $.ajax({
                                type: "POST",
                                url: actionUrl,
                                data: form_data,
                                enctype: "multipart/form-data",
                                processData: false,
                                contentType: false,
                                success: function (data) {
                                    if (data.status == 'success') {
                                        refresh_url = $('#timerecords_list').data('refresh_url');
                                        if (typeof refresh_url !== "undefined") {
                                            $.ajax({
                                                type: 'POST', url: refresh_url, async: false, dataType: 'json',
                                                success: function (data) {
                                                    $('#timerecords_list').html(data.data.content);
                                                    $('#timetracking-total').text(data.data.timerecords_sum);
                                                },
                                                error: function (data) { // if error occured
                                                    bootbox.alert('Chyba při provádění operace');
                                                }
                                            });
                                        }
                                    } else {
                                        bootbox.alert(data.msg);
                                    }
                                },
                                error: function (data) { // if error occured
                                    bootbox.alert(data.responseJSON.msg + ': ' + data.responseJSON.data[0]);
                                },
                                complete: function () {
                                    $('#editTimeTrackingMCRM').html('');
                                }
                            });
                            $('#editTimeTrackingMCRM').modal('hide');
                        });
                        $('#editTimeTrackingMCRM').modal('show');
                    } else {
                        bootbox.alert(data.msg);
                    }
                },
                error: function (data) { // if error occured
                    bootbox.alert('Chyba při provádění operace');
                }
            });
        }
    });

    const toastLive = document.getElementById('liveToast')
    const toastBootstrap = bootstrap.Toast.getOrCreateInstance(toastLive);

    $(document).on('click', 'a.custom-action-button', function (e) {
        e.preventDefault();
        $('#liveToast').removeClass(function (index, className) {
            return (className.match(/\bbg-\S+/g) || []).join(' ');
        });
        var type = $(this).data('type');
        if (type == 'ajax') {
            var webhook_data = $(this).data('webhook_params');
            var webhook_url = $(this).data('webhook_url');
            $.ajax({
                type: 'POST', url: webhook_url, data: webhook_data, async: true,
                success: function (data) {
                    $('#liveToast').addClass('bg-success-subtle');
                    $('.toast-custom-action-body').html('Operace úspěšně spuštěna');
                    console.log('OK: ' + data);
                    toastBootstrap.show();
                },
                error: function (data) { // if error occured
                    $('#liveToast').addClass('bg-danger-subtle');
                    $('.toast-custom-action-body').html('Chyba při provádění operace');
                    console.log('Chyba: ' + data);
                    toastBootstrap.show();
                }
            });
        } else if (type == 'link') {
            window.open($(this).attr('href'), '_blank');
            $('#liveToast').addClass('bg-success-subtle');
            $('.toast-custom-action-body').html('Bylo otevřeno nové okno s obsahem');
            toastBootstrap.show();
            return true;
        } else {
            $('#liveToast').addClass('bg-danger-subtle');
            $('.toast-custom-action-body').html('Nepodporovaný typ operace');
            toastBootstrap.show();
            return false;
        }

    });

    $(document).on('click', '.update-custom-field', function (e) {
        e.preventDefault();
        var url = $(this).data('form_url');
        if (typeof url !== "undefined") {
            $.ajax({
                type: 'GET', url: url, async: false, dataType: 'json',
                success: function (data) {
                    if (data.status == 'success') {
                        $('#updateCustomFieldModalContent').html(data.data.content);
                    } else {
                        bootbox.alert(data.msg);
                    }
                },
                error: function (data) { // if error occured
                    bootbox.alert('Chyba při provádění operace');
                }
            });
        }
    });

    $(document).on('click', '.delete-custom-field', function (e) {
        e.preventDefault();
        var url = $(this).data('delete_url');
        bootbox.confirm({
            title: 'Potvrzení',
            backdrop: true,
            message: 'Opravdu chcete smazat volitelné pole?',
            buttons: {
                confirm: { label: 'Ano', className: 'btn-success' },
                cancel: { label: 'Ne', className: 'btn-danger' }
            },
            callback: function (result) {
                if (result) {
                    document.location.href = url;
                } else {
                    null;
                }
            }
        });
    });

    $(document).on('click', '.update-custom-field-group', function (e) {
        e.preventDefault();
        var url = $(this).data('form_url');
        if (typeof url !== "undefined") {
            $.ajax({
                type: 'GET', url: url, async: false, dataType: 'json',
                success: function (data) {
                    if (data.status == 'success') {
                        $('#updateCustomFieldGroupModalContent').html(data.data.content);
                    } else {
                        bootbox.alert(data.msg);
                    }
                },
                error: function (data) { // if error occured
                    bootbox.alert('Chyba při provádění operace');
                }
            });
        }
    });

    $(document).on('click', '.delete-custom-field-group', function (e) {
        e.preventDefault();
        var url = $(this).data('delete_url');
        bootbox.confirm({
            title: 'Potvrzení',
            backdrop: true,
            message: 'Opravdu chcete smazat skupinu včetně existujících polí?',
            buttons: {
                confirm: { label: 'Ano', className: 'btn-success' },
                cancel: { label: 'Ne', className: 'btn-danger' }
            },
            callback: function (result) {
                if (result) {
                    document.location.href = url;
                } else {
                    null;
                }
            }
        });
    });

    $(document).on('change', '.new_custom_field_group_id', function (e) {
        var selected_val = $(this).val();
        console.log(selected_val);
        if (parseInt(selected_val) == 0) {
            $('#new_custom_field_create_new_group').removeClass('d-none');
            $('.new_custom_field_new_group_name_input').prop('disabled', false);
        } else {
            $('#new_custom_field_create_new_group').addClass('d-none');
            $('.new_custom_field_new_group_name_input').prop('disabled', true);
        }
        return true;
    });

    $(document).on('change', '.update_custom_field_group_id', function (e) {
        var selected_val = $(this).val();
        console.log(selected_val);
        if (parseInt(selected_val) == 0) {
            $('#update_custom_field_create_new_group').removeClass('d-none');
            $('.update_custom_field_new_group_name_input').prop('disabled', false);
        } else {
            $('#update_custom_field_create_new_group').addClass('d-none');
            $('.update_custom_field_new_group_name_input').prop('disabled', true);
        }
        return true;
    });

    $(document).on('click', '.show-object-detail-in-report', function (e) {
        e.preventDefault();
        var url = $(this).attr('href');
        if (typeof url !== "undefined") {
            $.ajax({
                type: 'GET', url: url, async: true, dataType: 'html',
                success: function (data) {
                    var content = $(data).find('.content');
                    content.find('nav[aria-label="breadcrumb"]').remove();
                    content.find('footer').remove();
                    $('#object-detail-offcanvas-place').html(content.html());
                    $('#object-detail-offcanvas-button-detail').prop('href', url);
                    if (typeof window.initDynamicContent === 'function') {
                        window.initDynamicContent($('#object-detail-offcanvas-place'));
                    }
                },
                error: function (data) { // if error occured
                    bootbox.alert('Chyba při načítání detailu: ' + data.statusText);
                }
            });
        }
        console.log(url);
    });

    $(document).on('click', '.show-message-preview', function (e) {
        e.preventDefault();
        var url = $(this).data('url');
        if (typeof url !== "undefined") {
            $.ajax({
                type: 'GET',
                url: url,
                async: false,
                dataType: 'json',
                processData: false,
                contentType: false,
                success: function (data) {
                    if (data.status == 'success') {
                        $('#previewMessageModalBody').html(data.data.content);
                        var iframe = $('#previewMessageModalBody').find('iframe#preview')[0];
                        var emailBody = data.data.emailBody;

                        if (iframe) {
                            var writeContentToIframe = function () {
                                iframe.contentDocument.open();
                                iframe.contentDocument.write(emailBody);
                                iframe.contentDocument.close();
                            };

                            iframe.onload = writeContentToIframe;
                            if (iframe.contentDocument.readyState === 'complete' || iframe.contentDocument.readyState === 'interactive') {
                                writeContentToIframe();
                            }
                        }

                        $('#previewMessageModal').modal('show');
                    }
                },
                error: function () {
                    bootbox.alert('Chyba při provádění operace');
                }
            });
        }
    });

    $(document).on('click', '.mail-log-attachment-preview', function (e) {
        e.preventDefault();
        var url = $(this).data('preview_url');
        if (!url) {
            return;
        }
        $.ajax({
            type: 'POST', url: url, dataType: 'json',
            success: function (data) {
                if (data && data.status === 'success' && data.data && data.data.content) {
                    $('#commonFilePreviewModalBody').html(data.data.content);
                    var modalEl = document.getElementById('commonFilePreviewModal');
                    bootstrap.Modal.getOrCreateInstance(modalEl).show();
                } else {
                    bootbox.alert((data && data.msg) || 'Náhled se nepodařilo načíst.');
                }
            },
            error: function () {
                bootbox.alert('Chyba při načítání náhledu.');
            }
        });
    });

    $(document).on('click', '.restart-message-job', function (e) {
        e.preventDefault();
        var $btn = $(this);
        var url = $btn.data('url');
        if (!url) {
            return;
        }
        bootbox.confirm({
            title: 'Opravdu chcete tuto zprávu znovu odeslat?',
            message: 'Zpráva bude znovu zařazena do fronty a odeslána.',
            backdrop: true,
            buttons: {
                confirm: { label: 'Ano', className: 'btn-success' },
                cancel: { label: 'Zrušit', className: 'btn-secondary' }
            },
            callback: function (confirmed) {
                if (!confirmed) {
                    return;
                }
                $btn.prop('disabled', true);
                $.ajax({
                    type: 'POST',
                    url: url,
                    dataType: 'json',
                    success: function (data) {
                        if (data.status === 'success') {
                            var $badge = $('.message-state-badge');
                            $badge.removeClass('badge-phoenix-danger').addClass('badge-phoenix-primary').text('Nová');
                            var $table = $btn.closest('table');
                            if ($table.length && $.fn.dataTable && $.fn.dataTable.isDataTable($table[0])) {
                                $table.DataTable().ajax.reload(null, false);
                            }
                            $btn.remove();
                            bootbox.alert(data.data.message || 'Zpráva byla zařazena k opětovnému odeslání.');
                        } else {
                            bootbox.alert(data.msg || 'Chyba při restartu zprávy.');
                            $btn.prop('disabled', false);
                        }
                    },
                    error: function (xhr) {
                        var msg = (xhr && xhr.responseJSON && xhr.responseJSON.msg) ? xhr.responseJSON.msg : ('Chyba při provádění operace (HTTP ' + (xhr ? xhr.status : '?') + ').');
                        bootbox.alert(msg);
                        $btn.prop('disabled', false);
                    }
                });
            }
        });
    });

    $(document).on('click', '.update-core-note', function (e) {
        e.preventDefault();
        $('#updateModelNoteModal').modal('show');
    });

    $(document).on('submit', '#form-model-note-update', function (e) {
        e.preventDefault();
        var form = $(this);
        var actionUrl = form.attr('action');
        var form_data = new FormData(form[0]);
        $.ajax({
            type: "POST",
            url: actionUrl,
            data: form_data,
            processData: false,
            contentType: false,
            success: function (data) {
                if (data.status == 'success') {
                    $('.object-note-content').html(data.data.note);
                    $('#liveToast').addClass('bg-success-subtle');
                    $('.toast-custom-action-body').html('Poznámka byla uložena');
                    toastBootstrap.show();
                } else {
                    bootbox.alert(data.msg);
                }
            },
            error: function (data) { // if error occured
                bootbox.alert(data.responseJSON.msg + ': ' + data.responseJSON.data[0]);
            },
            complete: function () {
                $('#updateModelNoteModal').modal('hide');
            }
        });
    });

    $(document).on('submit', '#connect-contact-person-form', function (e) {
        e.preventDefault();
        var form = $(this);
        var actionUrl = form.attr('action');
        var form_data = new FormData(form[0]);
        $.ajax({
            type: "POST",
            url: actionUrl,
            data: form_data,
            processData: false,
            contentType: false,
            success: function (data) {
                if (data.status == 'success') {
                    window.location.reload(true);
                } else {
                    bootbox.alert(data.msg);
                }
            },
            error: function (data) { // if error occured
                bootbox.alert(data.responseJSON.msg + ': ' + data.responseJSON.data[0]);
            }
        });
    });

    $(document).on('click', '.disconnect-contact-person-button', function (e) {
        e.preventDefault();
        var actionUrl = $(this).attr('href');
        bootbox.confirm({
            title: 'Potvrzení',
            backdrop: true,
            message: 'Opravdu chcete smazat kontaktní osobu z objektu?',
            buttons: {
                confirm: { label: 'Ano', className: 'btn-success' },
                cancel: { label: 'Ne', className: 'btn-danger' }
            },
            callback: function (result) {
                if (result) {
                    $.ajax({
                        type: "GET",
                        url: actionUrl,
                        processData: false,
                        contentType: false,
                        success: function (data) {
                            if (data.status == 'success') {
                                window.location.reload(true);
                            } else {
                                bootbox.alert(data.msg);
                            }
                        },
                        error: function (data) { // if error occured
                            bootbox.alert(data.responseJSON.msg + ': ' + data.responseJSON.data[0]);
                        }
                    });
                } else {
                    null;
                }
            }
        });
    });

    $(document).on('change', '#businesscase-client_uuid', function (e) {
        e.preventDefault();
        var parent_ident = $('#load-address-from-upper-object').data('parent_ident');
        var parent_uuid = $(this).val();
        if (parent_uuid.length == 0 || parent_uuid == undefined) {
            $('#load-address-from-upper-object-list').html('');
            return false;
        }
        var load_url = $('#load-address-from-upper-object').data('load_url') + parent_ident + '&parent_uuid=' + parent_uuid;
        $.ajax({
            type: "GET",
            url: load_url,
            processData: false,
            contentType: false,
            success: function (data) {
                if (data.status == 'success') {
                    $('#load-address-from-upper-object-list').html(data.data.content);
                } else {
                    bootbox.alert(data.msg);
                }
            },
            error: function (data) { // if error occured
                bootbox.alert(data.responseJSON.msg + ': ' + data.responseJSON.data[0]);
            }
        });
    });

    $(document).on('change', '#place-client_uuid', function (e) {
        e.preventDefault();
        var parent_ident = $('#load-address-from-upper-object').data('parent_ident');
        var parent_uuid = $(this).val();
        if (parent_uuid.length == 0 || parent_uuid == undefined) {
            $('#load-address-from-upper-object-list').html('');
            return false;
        }
        var load_url = $('#load-address-from-upper-object').data('load_url') + parent_ident + '&parent_uuid=' + parent_uuid;
        $.ajax({
            type: "GET",
            url: load_url,
            processData: false,
            contentType: false,
            success: function (data) {
                if (data.status == 'success') {
                    $('#load-address-from-upper-object-list').html(data.data.content);
                } else {
                    bootbox.alert(data.msg);
                }
            },
            error: function (data) { // if error occured
                bootbox.alert(data.responseJSON.msg + ': ' + data.responseJSON.data[0]);
            }
        });
    });

    $(document).on('click', '.stored-address-selector', function (e) {
        e.preventDefault();
        var addr_uuid = $(this).data('addr_uuid');
        var load_url = $('#load-address-from-upper-object').data('load_detail_url') + addr_uuid;
        $.ajax({
            type: "GET",
            url: load_url,
            processData: false,
            contentType: false,
            success: function (data) {
                if (data.status == 'success') {
                    console.log(data.data);
                    $('#address-street').val(data.data.street);
                    $('#address-city').val(data.data.city);
                    $('#address-zip').val(data.data.zip);
                    $('#address-region_id').val(data.data.region_id).change();
                    $('#address-country_id').val(data.data.country_id).change();
                    if ($('#address-lat').length == 1) {
                        $('#address-lat').val(data.data.lat);
                    }
                    if ($('#address-lng').length == 1) {
                        $('#address-lng').val(data.data.lng);
                    }
                } else {
                    bootbox.alert(data.msg);
                }
            },
            error: function (data) { // if error occured
                bootbox.alert(data.responseJSON.msg + ': ' + data.responseJSON.data[0]);
            }
        });
    });

    const address_parent_ident = $('#load-address-from-upper-object').data('parent_ident');
    if (address_parent_ident === 'place') {
        const first_address = $('#load-address-from-upper-object-list a.stored-address-selector').first();
        if (first_address.length > 0) {
            first_address.click();
        }
    }

    $(document).on('change', '#contactpersonentity-contact_person_uuid', function (e) {
        e.preventDefault();
        console.log($(this).val());
        if ($(this).val() == 'add') {
            $('#contactPersonAddNewForm').removeClass('d-none');
            $('#contactPersonAddNewForm').find(':input').prop('disabled', false);
        } else {
            $('#contactPersonAddNewForm').addClass('d-none');
            $('#contactPersonAddNewForm').find(':input').prop('disabled', true);
        }
    });

    $(document).on('click', ".openall", function (e) {
        e.preventDefault();
        $(this).closest('.virtual_objects_list').find(".collapse").collapse('show');
        //$(this).closest('.virtual_objects_list').find(".fa-chevron-right").addClass("fa-rotate-90");
        $(this).removeClass('openall').addClass('closeall').html('Zabalit vše');
    });

    $(document).on('click', ".closeall", function (e) {
        e.preventDefault();
        $(this).closest('.virtual_objects_list').find(".collapse").collapse('hide');
        //$(this).closest('.virtual_objects_list').find(".fa-chevron-right").removeClass("fa-rotate-90");
        $(this).removeClass('closeall').addClass('openall').html('Rozbalit vše');
    });

    function initTags()
    {
        $(document).on('click', 'a.object_tag_add', function (e) {
            e.preventDefault();
            var url = $(this).data('ajax_url');
            if (typeof url !== "undefined") {
                //console.log(url);
                $.ajax({
                    type: 'POST', url: url, async: false, dataType: 'json',
                    success: function (data) {
                        if (data.status == 'success') {
                            //console.log(data);
                            $('#editObjectTagsModal').html(data.data.content).on('shown.bs.modal', function () {
                                var select = $('#editObjectTagsModal select[autofocus]:first');
                                var input = $('#editObjectTagsModal input[autofocus]:first');
                                if (select.length > 0) {
                                    select.focus();
                                }
                                if (input.length > 0) {
                                    input.focus();
                                }
                                var choice = $('#editObjectTagsModal select.tag_choice');
                                if (choice.length > 0) {
                                    let choices = new Choices(choice[0], {
                                        removeItemButton: true,
                                        placeholder: true,
                                        loadingText: 'Načítání...',
                                        noResultsText: 'Nebyly nalezeny žádné výsledky',
                                        noChoicesText: 'Žádné možnosti na výběr',
                                        itemSelectText: 'Klikněte pro výběr',
                                        uniqueItemText: 'Lze přidat pouze jedinečné hodnoty',
                                    });
                                    $('#editObjectTagsModal #tag-switch').change(function () {
                                        if ($(this).prop('checked')) {
                                            $('#editObjectTagsModal #tag-select').addClass('d-none');
                                            $('#editObjectTagsModal #tag-new').removeClass('d-none');
                                        } else {
                                            $('#editObjectTagsModal #tag-new').addClass('d-none');
                                            $('#editObjectTagsModal #tag-select').removeClass('d-none');
                                        }
                                    });
                                }
                            }).on('hidden.bs.modal', function () {
                                $('#editObjectTagsModal').html('');
                            });
                            $('#object-tags-api-form').on('submit', function (e) {
                                e.preventDefault();
                                var form = $(this);
                                var actionUrl = form.attr('action');
                                var form_data = new FormData(form[0]);
                                $.ajax({
                                    type: "POST",
                                    url: actionUrl,
                                    data: form_data,
                                    enctype: "multipart/form-data",
                                    processData: false,
                                    contentType: false,
                                    success: function (data) {
                                        if (data.data.reload) {
                                            window.location.reload();
                                        }
                                    },
                                    error: function (data) { // if error occured
                                        bootbox.alert(data.responseJSON.msg + ': ' + data.responseJSON.data[0]);
                                    },
                                    complete: function () {
                                        $('#editObjectTagsModal').html('');
                                    }
                                });
                                $('#editObjectTagsModal').modal('hide');
                            });
                            $('#editObjectTagsModal').modal('show');
                        } else {
                            bootbox.alert(data.msg);
                        }
                    },
                    error: function (data) { // if error occured
                        bootbox.alert('Chyba při provádění operace');
                    }
                });
            }
        });

        $(document).on('click', 'a.object_tag_remove', function (e) {
            e.preventDefault();
            var ajax_url = $(this).data('ajax_url');
            var element = $(this);
            if (typeof ajax_url !== "undefined") {
                $.ajax({
                    type: 'POST', url: ajax_url, async: false, dataType: 'json',
                    success: function (data) {
                        if (data.status == 'success') {
                            element.parent().remove();
                            if (data.data.reload) {
                                window.location.reload();
                            }
                        } else {
                            bootbox.alert(data.msg);
                        }
                    },
                    error: function (data) { // if error occured
                        bootbox.alert('Chyba při provádění operace');
                    }
                });
            }
        });
    };

    if ($('a.object_tag_add').length > 0) {
        initTags();
    }

});

$(document).ready(function() {
    // Definujeme šablonu pro dropdown
    const dropdown = $(`
        <li class="nav-item dropdown" id="nav-dropdown-more">
            <a class="nav-link dropdown-toggle dropdown-caret-none" data-bs-toggle="dropdown" href="#" role="button" aria-expanded="false">
                <span class="fa-solid fa-ellipsis tab-icon-color"></span>
            </a>
            <ul class="dropdown-menu dropdown-menu-end shadow" id="nav-dropdown-menu-more"></ul>
        </li>
    `);

    function arrangeTabs() {
        const nav = $('#myTab.nav-responsive');
        const tabSpacing = 16;

        // 1. RESET: Přesuneme vše z dropdownu zpět do hlavní navigace
        const movedItems = $('#nav-dropdown-menu-more').children();
        if (movedItems.length > 0) {
            movedItems.each(function() {
                $(this).addClass('nav-item text-nowrap me-2');
                $(this).find('.dropdown-item').removeClass('dropdown-item').addClass('nav-link');
                $(this).insertBefore('#nav-dropdown-more'); // Vrátíme je před dropdown
            });
        }
        // Odstraníme dropdown, abychom mohli čistě měřit
        dropdown.detach();

        // Získáme všechny taby
        const tabs = nav.find('> li.nav-item');

        // 2. MĚŘENÍ: Spočítáme celkovou šířku všech tabů vedle sebe
        let totalTabsWidth = 0;
        tabs.each(function() {
            totalTabsWidth += $(this).outerWidth(true) + tabSpacing; // true = včetně marginů (me-2)
        });

        // DŮLEŽITÉ: Měříme šířku RODIČE navigace.
        const containerWidth = nav.parent().width();

        // 3. KONTROLA: Pokud se vše vejde, rovnou končíme
        if (totalTabsWidth <= containerWidth) {
            return;
        }

        // 4. PŘESUN: Vše se nevejde. Přidáme "Další" tlačítko a změříme ho
        nav.append(dropdown);
        const moreWidth = dropdown.outerWidth(true);

        // O kolik místa přijdeme kvůli samotnému "Další" tlačítku + malá rezerva proti nechtěnému zalomení
        const availableSpace = containerWidth - moreWidth - tabSpacing;

        let usedSpace = 0;
        let moveStarted = false;

        // Projdeme taby zleva doprava a co přečuhuje, letí do dropdownu
        tabs.each(function() {
            const tab = $(this);
            const tabWidth = tab.outerWidth(true) + tabSpacing;

            // Pokud jsme ještě nezačali přesouvat a tab se ještě vejde
            if (!moveStarted && (usedSpace + tabWidth) <= availableSpace) {
                usedSpace += tabWidth;
            } else {
                // Jakmile se jeden nevejde, přesouváme ho (a VŠECHNY NÁSLEDUJÍCÍ za ním) do dropdownu
                moveStarted = true;
                tab.removeClass('nav-item text-nowrap me-2');
                tab.find('.nav-link').removeClass('nav-link').addClass('dropdown-item');
                tab.appendTo('#nav-dropdown-menu-more');
            }
        });
    }

    // Spuštění po plném načtení DOMu a při každé změně velikosti okna
    arrangeTabs();
    $(window).on('resize', arrangeTabs);
});
